import { EGarageType } from '../../../../json_query';
import { changeGarage } from '../../../state/advanced/garage_type';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const Garage = getMultiSelectParam<EGarageType>(
  'Тип',
  [
    { title: 'Гараж', value: EGarageType.Garage },
    { title: 'Машиноместо', value: EGarageType.CarPlace },
    { title: 'Бокс', value: EGarageType.Box },
  ],
  'garage_type',
  changeGarage,
);
